export default __webpack_public_path__ + "static/media/KAVA.d4d2b461.svg";